import barba from '@barba/core';
import { gsap } from "gsap";

export default {
	name: 'default',
	leave({ current, next, trigger }) {
		document.dispatchEvent(new CustomEvent('disable-scroll'));
		document.dispatchEvent(new CustomEvent('remove-cursors'));
		barba.menu.close();
		barba.logoLayerDirector.handleTransition();
		barba.logoLayerDirector.newCode('');
	},
	afterLeave({ current, next, trigger }) {
		return new Promise(resolve => {

			const toPreloader = barba.logoLayerDirector.setTargetState('preloader');

			document.body.classList.add('is-animating');

			const fadeOut = gsap.to(current.container, {
				opacity: 0,
				ease: 'none',
				duration: 1.3,
				onComplete: () => {
					barba.colorManager.fadeTo(next.container, 1.3);
				}
			});

			const blurLayer = document.querySelector('[data-blur-layer]');
			blurLayer.classList.remove('blur-layer--blurred');

			Promise.all([toPreloader, fadeOut]).then(() => {
				resolve();
			});

		});
	},
	beforeEnter({ current, next, trigger }) {
		return new Promise(resolve => {

			barba.menu.update(next.container);

            gsap.set(next.container, {
                opacity: 0,
            });

            gsap.set(current.container, {
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                zIndex: -999
            });

			resolve();

        });
	},
	enter({ current, next, trigger }) {
		return new Promise(resolve => {

			const nextLogoSize = next.container.dataset.logoSize;
			barba.logoLayerDirector.setTargetState(nextLogoSize);

			window.scrollTo(0, -1);
			setTimeout(() => {
				window.scrollTo(0, -1);

				gsap.to(next.container, {
					opacity: 1,
					ease: 'none',
					duration: 2,
					onComplete: () => {
						resolve();
					},
				});

			}, 100);

		});
	},
	after({ current, next, trigger }) {
        return new Promise(resolve => {

			if(next.namespace=='template-shop-index') {
				if(window.matchMedia('(min-width:991px)').matches) {
					resolve();
					return;
				}
			}

			if(next.namespace=='template-about') {
				resolve();
				return;
			}

			document.dispatchEvent(new CustomEvent('enable-scroll'));

            resolve();
        });
	},
};
